import { Component } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal";
import { WkTranslatePipe } from "@shared/index";

@Component({
    selector: "wk-pending-changes-popup",
    templateUrl: "./pending-changes-popup.component.html",
    styleUrl: "./pending-changes-popup.component.scss",
    standalone: false,
    host: { class: "wk-pcp" },
    providers: [WkTranslatePipe],
})
export class PendingChangesPopupComponent {
    bsModalRef?: BsModalRef;

    onDiscard?: () => void;
    onKeepEditing?: () => void;

    constructor() {}

    discardChanges(): void {
        if (this.onDiscard) {
            this.onDiscard();
        }
        this.bsModalRef?.hide();
    }

    keepEditing(): void {
        if (this.onKeepEditing) {
            this.onKeepEditing();
        }
        this.bsModalRef?.hide();
    }
}
